import React from 'react';
import Banner from '@cpg-its/ads.containers.banner';
import { LockedPageState } from '../models/locked-page-model';
import { ContentSpacer } from './layout/generic-content-spacer';
import { WysiwygWithReactLink } from './wysiwyg-with-react-link';

interface Props {
    lockedState: LockedPageState;
}

export function LockedPageMessage(props: Props) {
    const { lockedState } = props;

    if (!lockedState?.isLocked) {
        return null;
    }

    const renderMessageContent = () => {
        return (
            <>
                <div dangerouslySetInnerHTML={{ __html: lockedState.generalMessage }} />
                <ul>
                    {
                        lockedState.lockedSummaries.map((summary, i) => {
                            return (
                                <li key={i}>
                                    <WysiwygWithReactLink content={summary} />
                                </li>
                            );
                        })
                    }
                </ul>
            </>
        );
    };

    return (
        <div className='rich-text'>

            <ContentSpacer>
                <Banner banner={{
                    type: 'warning',
                    label: renderMessageContent(),
                }} />
            </ContentSpacer>

        </div>
    );
}